export const FavoritesIcon = () => {
    return (
        <svg
            width="24"
            height="21"
            viewBox="0 0 24 21"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M11.973 2.39183C13.2781 0.926976 15.2776 0 17.3609 0C21.0485 0 23.946 2.76948 23.946 6.29428C23.946 10.6166 19.8818 14.1392 13.7243 19.4763L13.7091 19.4894L11.973 21L10.2369 19.5008L10.1897 19.4597C4.05003 14.1269 0 10.6091 0 6.29428C0 2.76948 2.89747 0 6.58515 0C8.66846 0 10.6679 0.926976 11.973 2.39183Z"
                fill="currentColor"
            />
        </svg>
    );
};
